import React, { useState, useEffect } from 'react';

export default function LastHeartbeat({ timestamp }) {
  const [timeString, setTimeString] = useState('Loading...');

  useEffect(() => {
    if (!timestamp) {
      setTimeString('Never');
      return;
    }

    const updateTime = () => {
      const diffSeconds = Math.floor((Date.now() - new Date(timestamp).getTime()) / 1000);
      const diffMinutes = Math.floor(diffSeconds / 60);
      const diffHours = Math.floor(diffMinutes / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffSeconds < 60) setTimeString('<1 minute ago');
      else if (diffMinutes < 60) setTimeString(`${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`);
      else if (diffHours < 24) setTimeString(`${diffHours} hour${diffHours === 1 ? '' : 's'} ago`);
      else setTimeString(`${diffDays} day${diffDays === 1 ? '' : 's'} ago`);
    };

    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, [timestamp]);

  if (!timestamp) return null;

  return <div className="last-heartbeat heartbeat-ready">Last seen online: {timeString}</div>;
}
